import { StyleSheet } from 'aphrodite';
import { destructive, warningDark } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	notice: {
		color: warningDark,
		fontSize: 14,
		marginTop: 8,
		paddingLeft: 20,
		paddingRight: 20,
	},
	blocking: {
		color: destructive,
	},
});
